module.exports = __webpack_public_path__ + "img/set-scale-icon.9ecc24b4.svg";